import { getMembershipStatus, getStatusTone, formatStatus, type MembershipDbStatus } from '@/utils';
import { Badge } from '@/components/ui';


interface MembershipStatusBadgeProps {
  membership: {
    start_date: string | null;
    end_date: string | null;
    name?: string;
    status?: MembershipDbStatus;
    cancelled_at?: string | null;
  } | null;
  className?: string;
  isLoading?: boolean;
  /** Use an immutable submission timestamp when rendering historical membership data. */
  referenceDate?: Date;
}

export default function MembershipStatusBadge({ 
  membership, 
  className = "",
  isLoading = false,
  referenceDate,
}: MembershipStatusBadgeProps) {
  // Handle loading state
  if (isLoading) {
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-400 animate-pulse ${className}`}>
        Loading...
      </span>
    );
  }

  // Handle null membership
  if (!membership) {
    return (
      <Badge tone="red" className={className}>
        No Membership
      </Badge>
    );
  }

  // Handle null dates
  if (!membership.start_date || !membership.end_date) {
    return (
      <Badge tone="red" className={className}>
        No Membership
      </Badge>
    );
  }

  const displayStatus = getMembershipStatus(membership, referenceDate);

  return (
    <Badge tone={getStatusTone(displayStatus)} className={className}>
      {membership.name ? `${membership.name} - ` : ''}{formatStatus(displayStatus)}
    </Badge>
  );
} 